import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

import Column from "../../../common/components/Column"

export default function AdminCallingNumberDeleteDialog({
  open,
  assignment,
  onClose,
  onConfirm,
  saving,
  errorMessage,
}) {
  const phone = assignment?.twilio_voice_phone || "this number"

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Release calling number</DialogTitle>
      <DialogContent>
        <Column gap={2}>
          <Typography variant="body2">
            Release <strong>{phone}</strong> from Twilio and remove the
            assignment for{" "}
            {assignment?.concierge_name ||
              assignment?.concierge_email ||
              "this concierge"}{" "}
            /{" "}
            {assignment?.owner_name ||
              assignment?.owner_email ||
              "this account"}
            ?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This deletes the number from your Twilio account so recurring
            charges stop. This cannot be undone from the admin panel.
          </Typography>
          {errorMessage ? (
            <Typography color="error" variant="body2">
              {errorMessage}
            </Typography>
          ) : null}
        </Column>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={saving}
          onClick={() => onConfirm()}
        >
          Release from Twilio
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AdminCallingNumberDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  assignment: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  errorMessage: PropTypes.string,
}
